import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_LOT_URL } from '../../connection.data';
import { BasicService } from './basic.service';

/**
 * Consulta y mantiene los lotes relacionados con una orden de trabajo y/o una data
 * manual. La API valida la empresa y las relaciones; el frontend no accede
 * directamente a PostgreSQL.
 */
@Injectable()
export class LotService extends BasicService {
    constructor(http: HttpClient) {
        super(http);
        this.baseUrl = API_LOT_URL;
    }
}
